import React from 'react';
import { Grid, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { clientsLifeStageOptions } from './constant';
import FormLabelWithIcon from './FormLabelWithIcon';

export const ClientLifeStageOptionPicker = (
    { intl, options, onValueChange,
        field = 'lifeStage',
        classes = {}, required = true,
        name = 'clients-life-stage',
        label = 'clients-life-stage',
        labelStyle
    }) => {
    const opts = options == null ? {} : options;
    const raw = opts[field];
    const groupValue = raw == null ? '' : String(raw);

    return (
        <Grid className={classes?.sectionContainer || ''}>
            <FormLabelWithIcon
                iconName="Milestone"
                labelText={intl.formatMessage({ id: label })}
                type="blue"
                required={required}
                style={labelStyle}
            />
            <FormControl>
                <RadioGroup
                    row
                    aria-label={label}
                    name={name}
                    value={groupValue}
                    onChange={event => onValueChange(field, event.target.value, raw)}
                >
                    {clientsLifeStageOptions.map(({ value, label, characteristics }) => (
                        <FormControlLabel
                            key={value}
                            value={value}
                            control={<Radio color="primary" className={classes.radioOption} style={{ paddingTop: '2px', paddingBottom: '2px' }} />}
                            label={label[intl.locale]}
                        />
                    ))}
                </RadioGroup>
            </FormControl>
        </Grid>
    )
}